import { inject } from '@angular/core';

// 3D Party libs
import { jwtDecode } from 'jwt-decode';

// Models
import {
  AssetModel,
  AssetTypeModel,
  BranchModel,
  ProviderModel,
  ServiceModel,
  NonWorkingDayModel,
  ServiceRequestModel,
} from './core';

// CASL
import { unpackRules } from '@casl/ability/extra';
import {
  AbilityClass,
  createMongoAbility,
  ExtractSubjectType,
  MongoAbility,
  MongoQuery,
  PureAbility,
  SubjectRawRule,
} from '@casl/ability';

// Services
import { AuthService } from './core/services/auth.service';

type Actions = 'create' | 'read' | 'update' | 'delete' | 'report' | 'assignExecutor';
type Subjects =
  | 'service'
  | 'provider'
  | 'branch'
  | 'asset-type'
  | 'asset'
  | 'dashboard'
  | 'non-working-day'
  | 'property-manager.organization'
  | 'property-manager.building'
  | 'service-request'
  | ProviderModel
  | ServiceModel
  | BranchModel
  | AssetTypeModel
  | AssetModel
  | NonWorkingDayModel
  | ServiceRequestModel;

export type AppAbility = MongoAbility<[Actions, Subjects]>;
export const AppAbility = PureAbility as AbilityClass<AppAbility>;

/**
 * Defines the abilities for the application.
 * This function retrieves the token from the `AuthService`, decodes it using `jwtDecode`,
 * and creates a Mongo ability based on the decoded rules.
 *
 * @returns The created Mongo ability.
 */
export function defineAbilitiesFor() {
  const authService = inject(AuthService);

  const data: any = jwtDecode(authService.token);
  return createMongoAbility(
    unpackRules(data.rules) as SubjectRawRule<string, ExtractSubjectType<Subjects>, MongoQuery>[],
  );
}
